import stokvel from "../../assets/images/stokveel.png";
import { FaCircle, FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Stokvel() {
  return (
    <div className="w-full h-full flex md:p-10">
      <div
        className="relative md:py-10 w-full rounded-lg md:px-40 "
        style={{
          backgroundImage: `url(${stokvel})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/50 rounded-lg " />
        <div className="bg-black/60 rounded-lg shadow-2xl h-full grid md:grid-cols-3 relative">
          <div className="relative flex pb-5 items-center justify-center">
            <div className="md:absolute w-[18rem] md:-left-[7.5rem] md:top-1/2 md:-translate-y-1/2 flex flex-col md:items-start">
              <img src={stokvel} alt="" className="md:h-70 w-full rounded-lg" />
              <div className=" items-center justify-center w-full mt-4 flex gap-10">
                <Link
                  to={"https://github.com/23Mandla/Stokvel"}
                  target="blank"
                  className="border flex items-center gap-2 py-[2px] text-sm px-6 rounded-full"
                >
                  <p>Git</p> <FaExternalLinkAlt className="text-[8px]" />
                </Link>
                <Link
                  className="border text-sm px-3 py-[2px] rounded-full flex items-center gap-2"
                >
                  <FaCircle className="text-[8px] text-red-500" />
                  <p>Live</p>
                </Link>
              </div>
            </div>
          </div>
          <div className="md:col-span-2 order-first md:order-none flex gap-5 flex-col md:px-16 sm:px-10 p-5 justify-center ">
            <div className="w-full">
              <h1 className="md:text-xl sm:text-md text-xs font-bold">
                Stokvel
              </h1>
            </div>
            <div className="">
              <p className="md:text-sm text-xs">
                Stokvel llows members of a stokvel to register, join groups, and
                contribute money regularly while keeping track of who has paid
                and how much has been saved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
